( function( $ ) {
	'use strict';

	/*
	*	Show Dropdown on focus
	*/
	$( '.dd-input' ).on( 'focus', function() {
		$( '.dd-list' ).removeClass( 'dd-list--active' );
		$( this ).nextUntil( 'dd-list' ).addClass( 'dd-list--active' );
	} );

	/*
	*	Fill input with selected item
	*/
	$( '.dd-list__item' ).on( 'click', function() {
		var itemValue = $( this ).text();
		$( this ).parent().parent().removeClass( 'dd-list--active' )
			.parent().find( '.dd-input' ).val( itemValue );
	} );

	/*
	*	Close dropdown with click off
	*/
	$( document ).mouseup( function ( e ) {
		var container = $( '.dd-input, .dd-list' );
		if ( !container.is( e.target )
			&& 0 === container.has( e.target ).length )
		{
			container.removeClass( 'dd-list--active' );
		}
	} );

} )( jQuery );
